module.exports = __webpack_public_path__ + "img/TUR-B-1-I.b7b83bd3.png";